import { Layout, Menu } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import Header from '../../Home/Header'
import {  Row } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux';
import { getSchools } from '../../actions/school';
import { getAttendances } from '../../actions/attendance';
import { getReports, getReport } from '../../actions/report';
import { getStudentreports } from '../../actions/studentreport';
import { useParams } from 'react-router-dom';
import Report from '../Reports';
import Headers from './Headers';


const { Content } = Layout;

export default function Menus(props) {

  const {reportid} = useParams()
  const [arrreports, setarrreports] = useState({})
  const dispatch = useDispatch()
  const userSelector = useSelector(state=>state.userReducer)
  const {user, mid, schoolId} = userSelector
  const repid = reportid / ( 2 * 13 * 13 * 13 * 13)
  const reportSelector = useSelector(state=>state.reportReducer)
  const {reports, schools, sessions, terms, claszs:claszs1} = reportSelector


  useEffect(() => {
    if(schoolId > 0){
      let params = {
        data:JSON.stringify(
        {
          'id': schoolId
        }),
        cat:'selected_school',
        table:'schools',
        narration:'get school'
      }
      dispatch(getSchools(params))
    }
  }, [user])

  useEffect(() => {
    console.log(reports)
    Object.keys(reports).forEach(schoolid=>{
        let sessions = reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let terms = sessions[sessionid]
            Object.keys(terms).forEach(termid=>{
                let claszs = terms[termid]
                Object.keys(claszs).forEach(claszid=>{
                    let reps = claszs[claszid]
                    Object.keys(reps).forEach(repidx =>{
                      if(repidx == repid ){
                        let rep_data = reps[repidx]
                        let arr = {}
                        let sch = schools[schoolid] || null
                        let cla = claszs1[claszid] || null
                        arr['schoolname'] = sch !== null ?  sch?.abbrv : ''
                        arr['classname'] =  cla !== null ? cla?.name : ''
                        arr['reportname'] = rep_data.title
                        arr['schooldata'] = sch
                        arr['classdata'] = cla
                        arr['data'] = rep_data
                        setarrreports(arr)
                        localStorage.setItem('selectedresult', JSON.stringify(arr))
                      }
                    })
                })
            })              
        })
    })
  }, [reports])

  useMemo(() => {
    if(schoolId > 0 && mid > 0)
    {
      let params1 = {
        data:JSON.stringify(
        {
          'schoolid': schoolId,
          'studentid': mid
        }),
        cat:'select_result',
        table:'schools',
        narration:'get student records'
      }
      dispatch(getReports(params1)) 
    }
  }, [schoolId, mid])
  
  
//console.log(reports)
  useEffect(() => loadResult(arrreports))

  const loadResult = (d) =>{
    let reps = d.data
    if(
        parseInt(repid) > 0 && 
        typeof reps == 'object' &&
        reps !== 'null' &&
        reps !== 'undefined' &&
        Array.isArray(Object.keys(reps)) && 
        Object.keys(reps).length > 0
      )
    {
        //GET ALL rep FOR THE STUDENTS
        let cas = reps.ca || '';
        let terms = reps.termid || '';
        let sessions = reps.sessionid || '';
        let grd = reps.grade || '';
        let stg = reps.stage || '';
        let cv = parseInt(stg) === 1 ? cas : repid;
        let params = {
        data:JSON.stringify({
              'sessionid':sessions,
              'reportid':cv,
              'termid':terms,
              'stage':stg,
              'cas' : cas,
              'gradeid' : grd,
              'studentid' : mid
          }),
          cat:'selectreportmain',
          table:'studentscore',
          narration:'get reports'
        }
        dispatch(getStudentreports(params))
        loadResultAttendance(d)
    } 
  }
  const loadResultAttendance = (d) =>{
      let reps = d.data
      let term = reps?.termid || '';
      let session = reps?.sessionid || '';
      let params = {
          data:JSON.stringify(
          {
                'sessionid':session,
                'termid':term,
                'studentid' :mid
            }),
            cat:'selected_attendance',
            table:'studentscore',
            narration:'get attendances'
          }
          dispatch(getAttendances(params))
  }

  return (
    <Layout className="site-layout" style={{minHeight:'800px'}}>
    <Headers />
     <Content className="site-layout text-left" style={{ margin: '0 5rem', marginTop: 30 }}>
       <Row style={{minHeight:'800px'}}>
        <Report />
       </Row>
    </Content>
    </Layout>
  )
}
